import Cookies from 'js-cookie';

const COOKIE_NAME = 'NEXT_LOCALE';

function getRootDomain(): string | undefined {
  if (typeof window === 'undefined') {
    return undefined;
  }
  const { hostname } = window.location;
  if (hostname === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
    return undefined;
  }
  const parts = hostname.split('.');
  if (parts.length < 2) {
    return undefined;
  }
  return `.${parts.slice(-2).join('.')}`;
}

export function setLocaleCookie(locale: string): void {
  const domain = getRootDomain();
  Cookies.remove(COOKIE_NAME);
  if (domain) {
    Cookies.remove(COOKIE_NAME, { domain, path: '/' });
  }
  Cookies.set(COOKIE_NAME, locale, {
    ...(domain ? { domain } : {}),
    path: '/',
  });
}
